import { useQuery } from '@tanstack/react-query';
import { chatApi } from '@/services/chat';
import { authUtils } from '@/utils/auth';

/**
 * #4 — Total unread chat-message count for the current user.
 *
 * Seeds from GET /chat/unread-count and stays fresh by refetching on window
 * focus and on a short interval. The chat gateway also emits
 * `unread_count_changed` while the Activity Hub socket is connected; the poll
 * keeps the left-nav badge and dashboard alert accurate everywhere else.
 */
export function useUnreadChatCount() {
  const enabled = authUtils.isAuthenticated();

  const { data } = useQuery({
    queryKey: ['chat', 'unread-count'],
    queryFn: () => chatApi.getUnreadCount(),
    enabled,
    refetchOnWindowFocus: true,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });

  return data ?? 0;
}
